module.exports = __webpack_public_path__ + "static/media/nutrizones_new_brand_video.41148d52.jpg";